export interface IPageErrorState {
  textMain: string;
  textSub: string;
  linkText?: string;
  linkURL?: string;
  isButtonShown?: boolean;
}

// fix済みの汎用的な文言
const initialPageErrorState: IPageErrorState = {
  textMain: '情報を取得できませんでした。',
  textSub: 'システムエラーのため、情報を取得できませんでした。しばらくしてから再度お試しください。'
} as const;

export default (state: IPageErrorState = initialPageErrorState) => {
  return state;
};
